import React from 'react';
import { createRoot } from 'react-dom/client';
import ProductGrid from './product-grid';
import CartContext from '../cart/cart-context';

export default (element, data) => {
  const init = () => {
    const root = createRoot(element);
    root.render(
      <CartContext data={data}>
        <ProductGrid {...data} />
      </CartContext>,
    );
  };

  init();
};
